function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// sweetalert2-react-content v5.1.0

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('react-dom/client')) : typeof define === 'function' && define.amd ? define(['react', 'react-dom/client'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.sweetalert2ReactContent = factory(global.React, global.ReactDOM));
})(this, function (React, client) {
  'use strict';

  var mounts = [{
    key: 'title',
    getter: function getter(swal) {
      return swal.getTitle();
    }
  }, {
    key: 'html',
    getter: function getter(swal) {
      return swal.getHtmlContainer();
    }
  }, {
    key: 'confirmButtonText',
    getter: function getter(swal) {
      return swal.getConfirmButton();
    }
  }, {
    key: 'denyButtonText',
    getter: function getter(swal) {
      return swal.getDenyButton();
    }
  }, {
    key: 'cancelButtonText',
    getter: function getter(swal) {
      return swal.getCancelButton();
    }
  }, {
    key: 'footer',
    getter: function getter(swal) {
      return swal.getFooter();
    }
  }, {
    key: 'closeButtonHtml',
    getter: function getter(swal) {
      return swal.getCloseButton();
    }
  }, {
    key: 'iconHtml',
    getter: function getter(swal) {
      return swal.getIconContent();
    }
  }, {
    key: 'loaderHtml',
    getter: function getter(swal) {
      return swal.getLoader();
    }
  }];
  var noop = function noop() {};
  function withReactContent(ParentSwal) {
    /* Returns `params` separated into a tuple of `reactParams` (the React params that need to be rendered)
    and`otherParams` (all the other parameters, with any React params replaced with a space ' ') */
    function extractReactParams(params) {
      var reactParams = {};
      var otherParams = {};
      var mountKeys = mounts.map(function (mount) {
        return mount.key;
      });
      Object.entries(params).forEach(function (_ref) {
        var _ref3 = _slicedToArray(_ref, 2),
          key = _ref3[0],
          value = _ref3[1];
        if (mountKeys.includes(key) && /*#__PURE__*/React.isValidElement(value)) {
          reactParams[key] = value;
          otherParams[key] = ' ';
        } else {
          otherParams[key] = value;
        }
      });
      return [reactParams, otherParams];
    }
    function render(swal, reactParams) {
      Object.entries(reactParams).forEach(function (_ref2) {
        var _ref4 = _slicedToArray(_ref2, 2),
          key = _ref4[0],
          value = _ref4[1];
        var mount = mounts.find(function (mount) {
          return mount.key === key;
        });
        var domElement = mount.getter(ParentSwal);
        var root = client.createRoot(domElement);
        root.render(value);
        swal.__roots.push(root);
      });
    }
    function unrender(swal) {
      swal.__roots.forEach(function (root) {
        root.unmount();
      });
      swal.__roots = [];
    }
    return /*#__PURE__*/function (_ParentSwal) {
      function _class() {
        _classCallCheck(this, _class);
        return _callSuper(this, _class, arguments);
      }
      _inherits(_class, _ParentSwal);
      return _createClass(_class, [{
        key: "_main",
        value: function _main(params, mixinParams) {
          var _this = this;
          this.__roots = [];
          this.__params = Object.assign({}, mixinParams, params);
          var _extractReactParams = extractReactParams(this.__params),
            _extractReactParams2 = _slicedToArray(_extractReactParams, 2),
            reactParams = _extractReactParams2[0],
            otherParams = _extractReactParams2[1];
          var superWillOpen = otherParams.willOpen || noop;
          var superDidOpen = otherParams.didOpen || noop;
          var superDidDestroy = otherParams.didDestroy || noop;
          return _superPropGet(_class, "_main", this, 3)([Object.assign({}, otherParams, {
            willOpen: function willOpen(popup) {
              render(_this, reactParams);
              superWillOpen(popup);
            },
            didOpen: function didOpen(popup) {
              // read more about why this setTimeout is needed here:
              // https://github.com/reactwg/react-18/discussions/5 (What about the render callback?)
              setTimeout(function () {
                superDidOpen(popup);
              });
            },
            didDestroy: function didDestroy(popup) {
              superDidDestroy(popup);
              unrender(_this);
            }
          })]);
        }
      }, {
        key: "update",
        value: function update(params) {
          Object.assign(this.__params, params);
          unrender(this);
          var _extractReactParams3 = extractReactParams(this.__params),
            _extractReactParams4 = _slicedToArray(_extractReactParams3, 2),
            reactParams = _extractReactParams4[0],
            otherParams = _extractReactParams4[1];
          _superPropGet(_class, "update", this, 3)([otherParams]);
          render(this, reactParams);
        }
      }], [{
        key: "argsToParams",
        value: function argsToParams(args) {
          if ( /*#__PURE__*/React.isValidElement(args[0]) || /*#__PURE__*/React.isValidElement(args[1])) {
            var params = {};
            ['title', 'html', 'icon'].forEach(function (name, index) {
              if (args[index] !== undefined) {
                params[name] = args[index];
              }
            });
            return params;
          } else {
            return ParentSwal.argsToParams(args);
          }
        }
      }]);
    }(ParentSwal);
  }
  return withReactContent;
});